"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const cookie = require("../cookie.cjs");
const readValue = (value) => {
  return value.replace(/%3B/g, ";");
};
const getPreviewCookie = (cookieJar) => {
  const cookies = cookieJar.split("; ");
  let value;
  for (const cookie$1 of cookies) {
    const parts = cookie$1.split("=");
    const name = readValue(parts[0]).replace(/%3D/g, "=");
    if (name === cookie.preview) {
      value = readValue(parts.slice(1).join("="));
      continue;
    }
  }
  return value;
};
exports.getPreviewCookie = getPreviewCookie;
//# sourceMappingURL=getPreviewCookie.cjs.map
